import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { CalendarPeriod } from '@assetaccountant/api/models/calendar-period';
import { JwtHelperService } from '@auth0/angular-jwt';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class CalendarService {
  static jwthelper = new JwtHelperService();

  constructor(private http: HttpClient) {}

  getCalendarPeriods({
    registerId,
    periodStartDate,
    periodEndDate,
    yearsBefore,
    yearsAfter,
  }: {
    registerId?: number;
    periodStartDate?: string;
    periodEndDate?: string;
    yearsBefore?: number;
    yearsAfter?: number;
  } = {}): Observable<CalendarPeriod[]> {
    const headers: Record<string, string> = {};
    if (registerId) {
      headers.RegisterId = registerId.toString();
    }
    if (periodStartDate) {
      headers.PeriodStartDate = periodStartDate;
    }
    if (periodEndDate) {
      headers.PeriodEndDate = periodEndDate;
    }

    let params = new HttpParams();
    if (yearsBefore) {
      params = params.append('yearsBefore', yearsBefore.toString());
    }
    if (yearsAfter) {
      params = params.append('yearsAfter', yearsAfter.toString());
    }

    return this.http.get<CalendarPeriod[]>(
      `${environment.servicesApiUrl}/api/calendar/latestperiods`,
      {
        headers,
        params,
      },
    );
  }
}
